export default "__VITE_PUBLIC_ASSET__075482ce__"